module.exports = __webpack_public_path__ + "static/media/dixiefootball.e757491e.jpg";